import React from 'react';
import PropTypes from 'prop-types';

const LoadMoreButton = ({ onLoadMore, isLoading, disabled = false }) => {
  const handleClick = () => {
    if (!isLoading && !disabled && onLoadMore) {
      onLoadMore();
    }
  };

  return (
      <button
          type="button"
          className="btn btn-default btn-lg text-uppercase mt16 mb16"
          onClick={handleClick}
          disabled={isLoading || disabled}
      >
          {isLoading ? (
              <span>
                  <i className="fas fa-circle-notch fa-spin" /> Loading...
              </span>
      ) : (
          <span>Load More</span>
      )}
      </button>
  );
};

LoadMoreButton.propTypes = {
  onLoadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
  isLoading: false,
  disabled: false,
};

export default LoadMoreButton;
